export default {
  namespaced: true,
  state: {
    loading: true,
    locations: [],
  },
  mutations: {
    SET_DATA: (state, data) => {
      var locations = [];
      data.filter((d) => {
        d.deleting = false;
        locations.push(d);
      });
      state.locations = locations;
      state.loading = false;
    },
    ADD_LOCATION: (state, location) => {
      location.deleting = false;
      state.locations.push(location);
    },
    DELETE_LOCATION: (state, location) => {
      var results = state.locations.filter((loc, key) => {
        if (loc.id == location.id) {
          delete state.locations[key];
        } else {
          return loc;
        }
      });
      state.locations = results;
    },
  },
  actions: {
    get: function ({ commit, dispatch }, id) {
      this.$http
        .get(`vendors/${id}/locations`)
        .then((res) => {
          if (res.status == 200) {
            commit("SET_DATA", res.data);
          }
        })
        .catch((err) => {
          dispatch(
            "setError",
            {
              message: (err.data || {}).message || err,
              title: "Server Error",
            },
            { root: true }
          );
        });
    },
    save: function ({ commit, dispatch }, payload) {
      commit("SET_SAVING_STATE", true, { root: true });
      const requiredFields = ["city", "state", "country", "zip", "lat", "lng"];
      if (!payload || !payload.location) {
        return dispatch(
          "setError",
          {
            message: "Location not provided!",
            title: "Server Error",
          },
          { root: true }
        );
      }
      let hasError = false;
      requiredFields.forEach((item) => {
        if (!payload.location[item]) {
          hasError = true;
          return dispatch(
            "setError",
            {
              message: `${item} is missing!`,
              title: "Server Error",
            },
            { root: true }
          );
        }
      });
      if (hasError) {
        return;
      }
      this.$http
        .post(`vendors/${payload.vendor}/locations`, {
          ...payload.location,
          covered_areas: payload.areas,
        })
        .then((res) => {
          if (res.status == 200) {
            commit("SET_SAVING_STATE", false, { root: true });
            commit("ADD_LOCATION", res.data.data.location);
            dispatch("hideModal", null, { root: true });
          }
        })
        .catch((err) => {
          dispatch(
            "setError",
            {
              message: (err.data || {}).message || err,
              title: "Server Error",
            },
            { root: true }
          );
        });
    },
    update: function ({ dispatch }, location) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .put(
            `vendors/${location.vendor_id}/locations/${location.id}`,
            location
          )
          .then((res) => {
            if (res.status == 200) {
              return resolve(true);
            }
            return resolve(false);
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  (err.data || {}).message ||
                  ((err.data || {}).error || {}).message ||
                  err,
                title: "Server Error",
              },
              { root: true }
            );
            resolve(false);
          });
      });
    },
    delete: function ({ commit, dispatch }, location) {
      this.$http
        .delete(`vendors/${location.vendor_id}/locations/${location.id}`)
        .then((res) => {
          if (res.status == 200) {
            commit("DELETE_LOCATION", location);
          }
        })
        .catch((err) => {
          dispatch(
            "setError",
            {
              message: (err.data || {}).message || err,
              title: "Server Error",
            },
            { root: true }
          );
        });
    },
  },
};
